import { IconDefinition } from "@fortawesome/fontawesome-svg-core";

export enum ColumnRender {
    text,
    date,
    time,
    dateTime,
    integer,
    decimal,
    identity,
    checkCross,
    yesNo,
    deleted,
    color,
    customRenderer,
    synthesize
}


export enum FilterType {
    text,
    date,
    integer,
    select,
    boolean,
    checkCross,
    multiselect
}

export enum SortOrder {
    ascending,
    descending
}

export interface IColumn {
    title: string;
    member: string;
    canSort?: boolean;
    renderAs: ColumnRender;
    prefix?: string;
    suffix?: string;
    defaultVisible?: boolean;
    width: number;
    customRenderer: (item: any) => React.ReactElement
    default?: string;
    /** When set, overrides alignment from {@link ColumnRenderAlignment} for header and cell */
    align?: "start" | "center" | "end";
}

export type RowFormatterFunction = (item:any) => string | null;

export type IPagedListRowIndicator = {
    when: (item: unknown) => boolean;
    icon: IconDefinition;
    className?: string;
    title?: string;
    ariaLabel?: string;
};

export function ColumnRenderAlignment(renderAs: ColumnRender) {
    switch(renderAs) {
        case ColumnRender.integer:
        case ColumnRender.decimal:
        case ColumnRender.date:
        case ColumnRender.time:
        case ColumnRender.dateTime:
            return "text-start";
        case ColumnRender.synthesize:
            return "text-start";
        case ColumnRender.yesNo:
        case ColumnRender.checkCross:
        case ColumnRender.deleted:
            return "text-center";
        case ColumnRender.text:
        default:
            return "text-start";
    }
}

/** Bootstrap `text-*` class for column header and cells; respects {@link IColumn.align} when set. */
export function getColumnAlignClass(column: IColumn): string {
    if (column.align === "center") {
        return "text-center";
    }
    if (column.align === "end") {
        return "text-end";
    }
    if (column.align === "start") {
        return "text-start";
    }
    return ColumnRenderAlignment(column.renderAs);
}

export interface IPagedListAction {
    icon?: IconDefinition;
    text: string;
    primary?: boolean;
    startGroup?: boolean;
    onClick: (item: any) => void;
    availableMember?: string;
    availableFliped?: boolean;
    hideWhenMember?: string;
    secondaryBtn?: boolean;
    itemClassName?: string;
}

export interface IFilterValue {
    filter: IFilter;
    value: any;  
}

export interface IRequestValues {
    filter: Record<string, any>;
    offset: number,
    count: number
    sortBy: string,
    sortOrder: SortOrder
}

/** PagedList columns use camelCase JSON members; API sort enums use PascalCase names. */
export function toApiSortBy(member: string): string {
    if (!member) return member;
    return member.charAt(0).toUpperCase() + member.slice(1);
}

export interface IPagedViewResponse {
    offset: number;
    count: number;
    total: number;
    results: [];
}

export interface IFilter {
    title: string;
    member: string;
    type: FilterType;
    getUrl?: string;
    options?: any;
    defaultValue: any;
}

export interface IIdentity {
    id: string;
    email: string;
    displayName: string;
    isEnabled: boolean;
    isLocked: boolean;
    avatarRevision: boolean;
}
